import type { BariPostTreatmentReportData } from '@common/validation/customControls/bariPost/bariPostTreatmentReport/v1/bariPostTreatmentReportSchemaV1';

export const initialData: BariPostTreatmentReportData = {
    assets: [],
    datum_afgerond: null,
    doorverwijzing: null,
    relatedProcessActivityId: null,
    status_behandeling: null,
    toelichting: null,
};
